<template>
  <div class="details-component__content content">
    <v-client-table class="mobile-1070" :data="permits" :columns="columns" :options="options">
      <span v-if="props.row.receipt_download" slot="receipt_download" slot-scope="props">
        <a :href="props.row.download_link" target="_blank">
          <div class="icon-download"></div>
        </a>
      </span>
      <span v-if="props.row.client_receipt_download" slot="client_receipt_download" slot-scope="props">
        <a :href="props.row.client_receipt_link" target="_blank">
          <div class="icon-download"></div>
        </a>
      </span>
    </v-client-table>
  </div>
</template>

<script>

import { apiService } from '../api/services';

export default {
  mixins: [apiService],
  props: ['permits'],
  data() {
    return {
      columns: [
        'permit_nr', 'ticket_type', 'vehicle_nr', 'id_code', 'valid_from', 'valid_to',
        'permit_status', 'payment_status', 'total_sum', 'receipt_download', 'client_receipt_download',
      ],
      options: {
        perPageValues: [],
        perPage: 50,
        texts: {
          noResults: this.$t('tenants.no_matching_records'),
          count: this.$t('tables.count'),
        },
        filterable: false,
        sortable: ['permit_nr', 'ticket_type', 'vehicle_nr', 'id_code', 'valid_from', 'valid_to',
          'permit_status', 'payment_status', 'receipt_download'],
        rowClassCallback: () => 'VueTables__row',
        columnsClasses: {
          total_sum: 'left',
          receipt_download: 'center',
          client_receipt_download: 'center',
        },
        headings: {
          permit_nr: () => this.$t('kiosk_permits.permit_nr'),
          ticket_type: () => this.$t('kiosk_permits.ticket_type'),
          vehicle_nr: () => this.$t('kiosk_permits.vehicle_nr'),
          id_code: () => this.$t('kiosk_permits.id_code'),
          valid_from: () => this.$t('kiosk_permits.valid_from'),
          valid_to: () => this.$t('kiosk_permits.valid_to'),
          permit_status: () => this.$t('kiosk_permits.permit_status'),
          payment_status: () => this.$t('kiosk_permits.payment_status'),
          total_sum: () => this.$t('kiosk_permits.total_sum'),
          receipt_download: () => this.$t('kiosk_permits.receipt_download'),
          client_receipt_download: () => this.$t('kiosk_permits.client_receipt_download'),
        }
      }
    }
  }
}
</script>

<style lang="scss">
@import '~styles/app.scss';

.icon-download {
  width: 100%;
  height: 20px;
}

.left {
  text-align: left;
}

.center {
  text-align: center;
}

.VueTables__sortable {
  span {
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tenants/kiosk-permits/ui/PermitsList.vue